import { render, staticRenderFns } from "./ProductNoveltyPage.vue?vue&type=template&id=58e62058&scoped=true&"
import script from "./ProductNoveltyPage.vue?vue&type=script&lang=js&"
export * from "./ProductNoveltyPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e62058",
  null
  
)

export default component.exports